export const mockData = {
  company: {
    name: "Hack a Tech",
    mission: "Ser uma referência em modernização tecnológica para qualquer segmento",
    vision: "Liderar a transformação digital empresarial, capacitando organizações a alcançar seu máximo potencial",
    differential: "Trabalhamos de forma exclusiva para cada situação"
  },
  contact: {
    email: "comercial@hackatech.com.br",
    phone: null, // Ainda não disponível
    address: "Atendimento Nacional - Remoto e Presencial"
  },
  social: {
    linkedin: 'https://www.linkedin.com/company/hack-a-tech',
    github: 'https://github.com/hackatech',
    instagram: 'https://www.instagram.com/hackatech',
    youtube: 'https://www.youtube.com/@hackatech',
    twitter: 'https://x.com/hackatech', // opcional
  },
  colors: {
    primary: "#84bd00", // Verde
    secondary: "#e40087"  // Rosa/Magenta
  },
  services: [
    {
      id: 1,
      name: "Modernização Tecnológica",
      description: "Transformamos sistemas legados em soluções modernas e eficientes",
      features: ["Análise de sistemas atuais", "Migração segura", "Otimização de performance", "Treinamento de equipes"]
    },
    {
      id: 2,
      name: "Consultoria Estratégica",
      description: "Orientação especializada para definir a melhor estratégia tecnológica",
      features: ["Diagnóstico completo", "Roadmap tecnológico", "Gestão de mudanças", "Acompanhamento contínuo"]
    },
    {
      id: 3,
      name: "Infraestrutura Cloud AWS",
      description: "Implementamos e gerenciamos soluções em nuvem AWS",
      features: ["Migração para nuvem", "Otimização de custos", "Monitoramento 24/7", "Backup e disaster recovery"]
    },
    {
      id: 4,
      name: "Desenvolvimento Sob Medida",
      description: "Criamos sistemas personalizados para seu negócio",
      features: ["Análise de requisitos", "Desenvolvimento ágil", "Integração de sistemas", "Suporte e manutenção"]
    }
  ],
  differentials: [
    {
      id: 1,
      name: "Pré-discovery Gratuito",
      description: "Análise inicial completa sem custo, identificando oportunidades"
    },
    {
      id: 2,
      name: "Processos End-to-End",
      description: "Acompanhamos todo o ciclo do projeto, desde a concepção até o suporte"
    },
    {
      id: 3,
      name: "Soluções Ágeis",
      description: "Metodologias ágeis para entregar valor rapidamente"
    },
    {
      id: 4,
      name: "Abordagem Exclusiva",
      description: "Cada projeto é único, desenvolvemos soluções personalizadas"
    }
  ],
  segments: [
    "Agronegócio",
    "Financeiro",
    "Varejo",
    "Saúde",
    "Educação",
    "Seguros",
    "Automotivo"
  ]
};